import React, { useEffect, useState } from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Box, Typography, Stack } from '@mui/material';
import { useSelector } from "react-redux";
import { fetchDashboardUserGenderDistribution } from "../../api/region";



const GenderDistributionPieChart = () => {
  const { filter } = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [chartOptionsState, setChartOptionsState] = useState({});
  // Calculate total for percentages
  // const totalValue = chartData.reduce((acc, item) => acc + item.y, 0);
  const [totalValue, setTotalValue] = useState(0);


  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchDashboardUserGenderDistribution(filter);

      // const chartData = [
      //   { name: 'Male', y: data.male, color: '#007bff' },
      //   { name: 'Female', y: 50, color: '#343a90' },
      //   { name: 'Non binary & others', y: 20, color: '#28a745' },
      // ];
      const male = data.find((item) => item._id === 'Male')?.count || 0;
      const female = data.find((item) => item._id === 'Female')?.count || 0;
      const other = data.find((item) => item._id === 'Other')?.count || 0;

      const chartData = [
        { name: 'Male', y: male, color: '#007bff' },
        { name: 'Female', y: female, color: '#343a90' },
        { name: 'Non binary & others', y: other, color: '#28a745' },
      ];
      const chartOptions = {
        chart: {
          type: 'pie',
          height: 200,
        },
        title: {
          text: undefined,
        },
        tooltip: {
          enabled: true,
          formatter: function () {
            const total = this.series.data.reduce((acc, point) => acc + point.y, 0);
            const percentage = ((this.point.y / total) * 100).toFixed(1);
            return `<b>${this.point.name}</b>: ${this.point.y} (${percentage}%)`;
          },
        },
        plotOptions: {
          pie: {
            innerSize: '65%',
            borderRadius: 8,
            dataLabels: { enabled: false },
            borderWidth: 4,
          },
        },
        colors: chartData.map((item) => item.color),
        series: [
          {
            name: 'Gender',
            data: chartData,
          },
        ],
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
      };

      setChartOptionsState(chartOptions);
      setTotalValue(chartData.reduce((acc, item) => acc + item.y, 0));
      setOptions(chartData);
      setIsLoading(false);
    } catch (err) {
      console.error('Error while loading user data', err);
    }
  };
  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filter)]);

  return (
    <Box sx={{ border: '1px solid #E8E8E8', p: 3, borderRadius: '12px' }}>
      <Typography sx={{ mb: 2, fontWeight: 500, fontSize: '20px', color: '#3C4043' }}>
        Gender Distribution
      </Typography>
      {isLoading ?
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading...
          </Typography>
        </Box> :
        <Box display="flex" alignItems="center" gap={4} sx={{ justifyContent: 'space-between' }}>
          {/* Left-side Legend */}
          <Box>
            <Stack spacing={1}>
              {options.map((item) => {
                const percent = ((item?.y / totalValue) * 100 || 0)?.toFixed(1) || 0;
                return (
                  <Box
                    key={item.name}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ gap: 1 }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 0.5 }}>
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          backgroundColor: item.color,
                          mr: 1.5,
                        }}
                      />
                      <Typography sx={{ flexGrow: 1, fontSize: '14px' }}>{item.name}</Typography>
                    </Box>
                    <Typography sx={{ fontWeight: 500, fontSize: '14px', whiteSpace: 'nowrap' }}>
                      {item.y} ({percent}%)
                    </Typography>
                  </Box>
                );
              })}
            </Stack>
          </Box>

          {/* Donut Chart */}
          <Box width={200} height={200}>
            <HighchartsReact highcharts={Highcharts} options={chartOptionsState} />
          </Box>
        </Box>
      }
    </Box>
  );
};

export default GenderDistributionPieChart;
